export const SET_VIDEO_LAYOUT_MODE = "SET_VIDEO_LAYOUT_MODE";
export const SET_REMOTE_PARTICIPANTS = "SET_REMOTE_PARTICIPANTS";
export const SET_VISIBLE_REMOTE_COUNTS = "SET_VISIBLE_REMOTE_COUNTS";
export const SET_LAYOUT_STYLE_PROPERTY = "SET_LAYOUT_STYLE_PROPERTY";
export const SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED = 'SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED';
export const SET_PROPERTY = "SET_PROPERTY";